import config from '@iotv/config'
import { getEnumShape } from '@iotv/iotv-v3-types'

const defaultAreaSubTypes = ['Coverage']

export const AreaSubType = [...defaultAreaSubTypes, ...(config.ventureTypeExtensions?.Area?.subtype || [])]

export const AreaSubTypeEnum = getEnumShape(AreaSubType)
